import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../../store/store';
import { connect } from 'react-redux';
import { ROUTES } from '../../../../routes';
import { useNavigate } from 'react-router';
import API from '../../../../api';

import Fetcher from '../../../../libraries/fetcher';
import ResourceOrderer from '../resourceOrderer';
import Util from '../util';
import { useLanguage } from '@languages/index';

const SNSOrderCeleb = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // brand
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_1,
        });
      }
    },
  });
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
  }

  const countCelebsRes = useQuery({
    queryKey: ['count_celebs:published', fetchBrandRes.data?.brand?.id],
    queryFn: async () => {
      try {
        const res = await API.BrandSns.countCelebrities({
          brandToken: props.auth.token,
          where: { is_published: true },
        });
        return res.data.count;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_2,
        });
      }
    },
    enabled: !!fetchBrandRes.data,
  });

  // fetcher
  const celebsFetcherRes = useQuery({
    queryKey: ['get_celebs_fetcher:published', fetchBrandRes.data?.brand?.id],
    queryFn: () =>
      new Fetcher(async (offset: number, limit: number) => {
        const res = await API.BrandSns.fetchCelebrities({
          brandToken: props.auth.token,
          where: { is_published: true },
          offset,
          limit,
        });
        return res.data.reviews;
      }),
    enabled: !!fetchBrandRes.data,
  });
  const removeFetcherQueries = () => {
    queryClient.removeQueries({
      queryKey: [`get_celebs_fetcher:published`],
      exact: false,
    });
  };

  useEffect(() => {
    return () => {
      queryClient.removeQueries({
        queryKey: ['count_celebs:published'],
        exact: false,
      });
      removeFetcherQueries();
    };
  }, []);

  return (
    <ResourceOrderer
      resourceName={languageTexts.celeb_order_text_1}
      resourceCount={countCelebsRes.data || 0}
      fetcher={celebsFetcherRes.data}
      initialFetchCount={18}
      adderForMore={18}
      makeItemTagFunc={(rsrc) => (
        <div>
          <img
            className="object-cover aspect-[0.7825] w-full h-full"
            src={Util.makeImageUrl('brand_sns/thumb-sm', rsrc.thumbnailUrl)}
          />
          <span className="text-[0.9375rem]">{rsrc.title}</span>
        </div>
      )}
      updateOrderFunc={async (ids) => {
        const res = await API.BrandSns.orderCelebrities({
          brandToken: props.auth.token,
          ids,
        });
        removeFetcherQueries();
      }}
    />
  );
};

export default connect(mapStateToProps, mapDispatchProps)(SNSOrderCeleb);
